import Resource from '../graphql/queries/queryResource.js';

export const state = () => ({
    resources: {},
});

export const actions = {
    async fetch(context, { url, path, fetchFullTranscripts }) {
        let request = {
            query: Resource.resource({ fetchFullTranscripts }),
            variables: { url: url },
        };

        if (this.app.$auth.loggedIn) {
            request = {
                ...request,
                context: { headers: { 'x-api-key': '' } },
            };
        }

        try {
            const result = await this.app.apolloProvider.defaultClient.query(request);

            await context.dispatch('fetched', {
                resource: result.data.resourceV2.resource,
                url: url,
                path: path,
            });
        } catch (e) {
            await context.dispatch('app/showServerError', {}, { root: true });
            await context.dispatch('fetched', {
                error: e,
                url: url,
                path: path,
            });
        }
    },

    async fetched(context, payload) {
        if (payload.error) {
            await context.commit('setByUrl', {
                url: payload.url,
                path: payload.path,
                error: payload.error,
            });
            await context.commit('ui/hideLoader', {}, { root: true });
            return;
        }

        if (payload.resource === null) {
            await context.commit('setByUrl', {
                url: payload.url,
                path: payload.path,
                error: {
                    message: 'error404',
                },
            });
            await context.commit('ui/hideLoader', {}, { root: true });
            return;
        }

        switch (payload.resource.__typename) {
            case 'ResourceProfileResponse':
                await context.commit('setByUrl', {
                    type: 'profile',
                    profile: payload.resource.profile,
                    url: payload.url,
                    path: payload.path,
                });
                break;

            case 'ResourcePostOnProfileResponse':
                await context.commit('setByUrl', {
                    type: 'post',
                    post: payload.resource.post,
                    url: payload.url,
                    path: payload.path,
                });
                break;

            case 'ResourceCampaignContributionResponse':
                await context.commit('setByUrl', {
                    type: 'campaignContribution',
                    campaign: payload.resource,
                    url: payload.url,
                    path: payload.path,
                });
                break;
        }

        context.commit('ui/hideLoader', {}, { root: true });
    },
};

export const mutations = {
    setByUrl(state, payload) {
        state.resources = { ...state.resources, [payload.path]: payload };
    },
};

export const getters = {
    getByUrl: (state) => (path) => {
        return state.resources[path];
    },
};
